import BuildingType from "@/roc/building/BuildingType";
import BuildingMaxLevel from "@/roc/building/BuildingMaxLevel";
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import {BuildingFlags} from '@/roc/building/BuildingTemplate';
import Happiness from '@/roc/effects/CultureBonus/Happiness';
import PassiveAura from "@/roc/effects/PassiveAura/PassiveAura";
import PassiveAuraType from "@/roc/effects/PassiveAura/PassiveAuraType";
import EffectAmount from "@/roc/effects/EffectAmount";

const LuxuriousHome = {
  id: "3",
  name: "Luxurious Home",
  width: 3,
  height: 2,
  type: BuildingType.HOME,
  era: "stoneAge",
  icon: "Worker",
  workers: 2,
  minLevel: 3,
  maxLevel: BuildingMaxLevel.THREE_OFF,
  url: 'https://riseofcultures.wiki.gg/wiki/Home_Cultures/Homes/Luxurious_Home',
  flags: BuildingFlags.LUXURIOUS,
  counts: {
    stoneAge: 2,
    bronzeAge: 4,
    minoanEra: 5,
    classicGreece: 6,
    earlyRome: 7,
    romanEmpire: 8,
    byzantineEra: 9,
    ageOfTheFranks: 9,
    feudalAge: 9,
    iberianEra: 10,
    kingdomOfSicily: 11,
    highMiddleAges: 12,
    earlyGothicEra: 12,
    lateGothicEra: 12,
  },
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asFlat(1 * 60 * 60),
      ProductionOutput
        .asPerLevel([
          0, 0, 917, 0, 0, 1113, 0, 0, 1346, 0, 0, 1633, 0, 0, 1950, 0, 0, 2275, 0, 0,
          2658, 0, 0, 3079, 0, 0, 3496, 0, 0, 3967, 0, 0, 4500, 0, 0, 5000, 0, 0,
          6250, 0, 0, 10000,
        ])
        .withOutput(ProductionOutputType.GOLD)
      ,
    ),
    new Happiness({
      stoneAge: [80, 160, 310],
      bronzeAge: [120, 240, 470],
      minoanEra: [160, 310, 630],
      classicGreece: [210, 420, 840],
      earlyRome: [260, 520, 1050],
      romanEmpire: [310, 630, 1260],
      byzantineEra: [370, 730, 1470],
      ageOfTheFranks: [450, 890, 1780],
      feudalAge: [520, 1050, 2100],
      iberianEra: [630, 1260, 2510],
      kingdomOfSicily: [760, 1520, 3040],
      highMiddleAges: [920, 1830, 3670],
      earlyGothicEra: [1100, 2200, 4400],
      lateGothicEra: [1280, 2570, 5130],
    }),
    new PassiveAura(
      PassiveAuraType.GRANTS_CAPITAL_CITY_WORKER,
      EffectAmount.asFlat(2),
    ),
  ]),
};

export default LuxuriousHome;
